import { ContactInformationFields } from '@boss/types/corporate-jobs';

export const getContactCardProps = (entry: ContactInformationFields, hasBackground: boolean | undefined) => {
  const { phoneNumber, email, address } = entry;

  return {
    phone: phoneNumber,
    email,
    address,
    textClassName: hasBackground ? 'text-white' : '',
  };
};

export default getContactCardProps;
